import { HOT_KEYS_CUSTOMIZATION, useFeatureFlag } from '@shared/util/featureFlags';

/**
 * Whether the full customizable hotkeys experience is enabled. While off,
 * only the `BASIC_HOTKEY_ACTIONS` are bound (to their defaults — overrides
 * are ignored), and the Preferences page shows them read-only.
 */
export function useHotkeyCustomizationEnabled(): boolean {
  return useFeatureFlag(HOT_KEYS_CUSTOMIZATION);
}
